import React, { useEffect, useState, useRef, RefObject } from "react";
interface TruncateRefProps {
  caption: string;
  ref: RefObject<HTMLDivElement>;
}
const useCaptionElement = ({
  caption
}: TruncateRefProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shouldTruncate, setShouldTruncate] = useState(false);
  useEffect(() => {
    setShouldTruncate(caption.length > 40);
  }, [caption]);
  const toggleIsShowingMore = () => setIsExpanded(prev => !prev);
  return {
    isExpanded,
    shouldTruncate,
    toggleIsShowingMore
  };
};
interface Props {
  caption: string;
  windowWidth: number;
}
const ReviewCaption = ({
  caption,
  windowWidth
}: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const isLargeScreen = windowWidth > 1024;
  const {
    isExpanded,
    shouldTruncate,
    toggleIsShowingMore
  } = useCaptionElement({
    caption,
    ref
  });
  const tailwindClasses = isLargeScreen ? "[&:not(:hover)]:truncate" : `${!isExpanded && "truncate"}`;
  if (!caption || !caption.trim()) {
    return <></>;
  }
  return <div className="absolute max-w-[90%] bottom-0 left-0 min-h-9 m-4 border-solid border-green-500 border-l-[3px] border-r-0 border-y-0 bg-opacity-90 shadow-md bg-white" data-sentry-component="ReviewCaption" data-sentry-source-file="ReviewCaption.tsx">
      <div className={`flex flex-row ${isExpanded ? "flex-col items-start" : ""}`}>
        <div ref={ref} className={`lg:box-border max-w-full px-4 py-2 text-sm font-semibold ${tailwindClasses}`}>
          {caption}
        </div>

        {!isLargeScreen && shouldTruncate && <button className={`border-none bg-transparent pb-2 ${isExpanded ? "pb-2 pl-4" : "py-2 pr-2"} mb-0 text-sm font-semibold whitespace-nowrap text-green-500`} type="button" onClick={toggleIsShowingMore}>
            {isExpanded ? "Read Less" : "Read More"}
          </button>}
      </div>
    </div>;
};
export default ReviewCaption;